import Head from "next/head";
import { EXAMPLE_PROFILE_URL } from "../../constants";
import Footer from "../common/Footer";
import Nav from "../common/nav";

export default function Curators() {
  return (
    <>
      <Head>
        <title>For the Curators | Gwak</title>
        <meta name="description" content="Become a curator of restaurants on Gwak." />
      </Head>
      <Nav/>
      <section className="py-20">
        <img
          className="absolute top-0 left-0 mt-24 hidden lg:block"
          src="/page-assets/icons/dots/blue-dot-left-bars.svg"
          alt=""
        />

        <div className="container mx-auto px-4">
          <div className="-mx-4 mb-12 flex flex-wrap items-center lg:mb-20">
            <div className="mb-10 w-full px-4 lg:mb-0 lg:w-1/2">
              <span className="text-sm font-semibold text-blue-400">
                Become a curator
              </span>
              <h2 className="font-heading mt-8 mb-10 text-5xl font-semibold">
                Become a curator
              </h2>
              <p className="text-xl text-gray-500">
                Rate, label, and comment on the places you love. Make different
                lists to share with different groups of people.
              </p>
            </div>
            <div className="relative w-full px-4 lg:w-1/2">
              <img
                className="relative rounded-lg object-cover"
                src="https://images.unsplash.com/photo-1581464647113-0196a7dc232b?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80"
                alt=""
              />
            </div>
          </div>
          <div className="-mx-4 flex flex-wrap">
            <div className="flex w-full items-start py-6 px-4 md:w-1/2">
              <span className="mr-6 inline-flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-blue-400 text-white">
                1
              </span>
              <p className="text-xl text-gray-500">
                Create different lists of restaurants <br />
                (e.g. Best in SF, NYC Brunch, LA Bars).
              </p>
            </div>
            <div className="flex w-full items-start py-6 px-4 md:w-1/2">
              <span className="mr-6 inline-flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-teal-400 text-white">
                2
              </span>
              <p className="text-xl text-gray-500">
                Rate, review, and write a short comment. <br />
                Think tweet-length.
              </p>
            </div>
            <div className="flex w-full items-start py-6 px-4 md:w-1/2">
              <span className="mr-6 inline-flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-400 text-white">
                3
              </span>
              <p className="text-xl text-gray-500">
                Share your lists with anyone. <br />
                Gwak creates a lightweight web page for you to share even with
                non-Gwak users.{" "}
                <a className="underline" href={EXAMPLE_PROFILE_URL}>
                  Example profile
                </a>
              </p>
            </div>
            <div className="flex w-full items-start py-6 px-4 md:w-1/2">
              <span className="mr-6 inline-flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-yellow-400 text-white">
                4
              </span>
              <p className="text-xl text-gray-500">
                Keep a log of the places you&apos;ve been.
              </p>
            </div>
          </div>
        </div>
      </section>
      <Footer/>
    </>
  );
}
